import { DelayCodeModel } from "../../Model/DelayCodeModel";
import { checkStatus, parseJSON } from "../Common";
import {  DelayCollectionModel } from "../../Model/DelayListCollection";
import {FltopsDelayData} from "../../Model/FltopsDelayData";
import { Flightsegmentmodel } from "../../Model/Flightsegmentmodel";
import { FlightDelayDetail } from "../../Model/FlightDelayDetail";
import { AircaftData } from "../../Model/AircraftData";
import { DefectReport } from "../../Model/DefectReport";
import { DelayListRecordWithAction } from "../../Model/DelayListRecordWithAction";
import { UpdateDelayCodeModel } from "../../Model/UpdateDelayCodeModel";

const apiUrl = process.env.REACT_APP_API_BASE_URL;



export async function Getdelaycodelist(  
    token: string
  ): Promise<DelayCodeModel[]> {
  
    const url=`${apiUrl}/DelayAndCancellation/GetDelayCodesList`
    return await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(checkStatus)
      .then(parseJSON)
      .catch((error: any) => {
        console.log("error while calling the api ", error);
        throw new Error("API Call failed: " + error.message + "");
      });
}

export async function GetMaintDelays(token: string, station: string, delayCode: string, flightDate: string, airlineCode: string = "AS"): Promise<DelayCollectionModel[]> {
    const encodedStation = encodeURIComponent(station);
    const encodedDelayCode = encodeURIComponent(delayCode);
    const encodedAirlineCode = encodeURIComponent(airlineCode);
    const url = `${apiUrl}/DelayAndCancellation/GetMaintDelays?airlineCode=${encodedAirlineCode}&station=${encodedStation}&delayCode=${encodedDelayCode}&flightDate=${flightDate}`;
   

    return await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });

}
export async function GetFltopsDelays(token: string, station: string, delayCode: string, flightDate: string): Promise<DelayCollectionModel[]> {
    const url = `${apiUrl}/DelayAndCancellation/GetFltopsDelays?airlineCode=AS&station=${station}&delayCode=${delayCode}&flightDate=${flightDate}`;
    
    return await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });

}

export function GetDelayCode(token: string, station: string, flightNumber: string, flightDate: string): Promise<string> {

    const url =`${apiUrl}/DelayAndCancellation/GetDelayCode?airlineCode=AS&station=${station}&flightNumber=${flightNumber}&flightDate=${flightDate}`;
   
    return fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });

}


export function GetFltopsDelayData(token:string, fltsegid:number):Promise<FltopsDelayData>
{
    const url =`${apiUrl}/DelayAndCancellation/GetFltopsDelayData?flightSegId=${fltsegid}`;
   
    return fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });
}

export async function SaveFlightDelayDetail(token: string,
    flightdelay:FlightDelayDetail
    ): Promise<DelayListRecordWithAction> {
    const url =`${apiUrl}/DelayAndCancellation/SaveFlightDelayDetailReturnWithAction?airlineCode=AS`;   
     return await fetch(url.toString(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(flightdelay)
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });

    };

export function GetFlightSegmentInfo(token: string, station: string, aircraftreg:string, flightNumber: string, flightDate: string): Promise<Flightsegmentmodel> {

    const url =`${apiUrl}/DelayAndCancellation/GetFlightSegmentInfo?flightNumber=${flightNumber}&flightDate=${flightDate}&delayStation=${station}&aircraftReg=${aircraftreg}`;
   
    return fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
        .then(checkStatus)
        .then(parseJSON)
        .catch((error: any) => {
            console.log("error while calling the api ", error);
            throw new Error("API Call failed: " + error.message + "");
        });

    }


export function GetMaintDelayDetail(token: string, maintDncId: string): Promise<FlightDelayDetail> {
        const url =`${apiUrl}/DelayAndCancellation/GetMaintDelayDetail?maintDncId=${maintDncId}`;

        return fetch(url.toString(), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
            .then(checkStatus)
            .then(parseJSON)
            .catch((error: any) => {
                console.log("error while calling the api ", error);
                throw new Error("API Call failed: " + error.message + "");
            });
    
        }

export function ValidateLogPageNumber(token: string,logPageNumber:string,airlineCode:string, itemNumber?: string): Promise<DefectReport> {
            const url = buildPopulateLogDataFromTraxUrl(logPageNumber, airlineCode, itemNumber);
            return fetchLogPageDetails(token, url);
            }

function buildPopulateLogDataFromTraxUrl(logPageNumber: string, airlineCode: string, itemNumber?: string): string {
            const encodedLogPageNumber = encodeURIComponent(logPageNumber);
            const encodedItemNumber = itemNumber ? encodeURIComponent(itemNumber) : "";
            const itemParam = encodedItemNumber ? `&item=${encodedItemNumber}` : "";
            return `${apiUrl}/DelayAndCancellation/PopulateLogDataFromTrax?ipLog=${encodedLogPageNumber}&airlineCode=${airlineCode}${itemParam}`;
}

function fetchLogPageDetails(token: string, url: string): Promise<DefectReport> {
            return fetch(url.toString(), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            })
                .then(checkStatus)
                .then(parseJSON)
                .catch((error: any) => {
                    console.log("error while calling the api ", error);
                    throw new Error("API Call failed: " + error.message + "");
                });
}

 export async function GetArrivalFlightDetail(token: string,flightIdentity:number): Promise<FlightDelayDetail> {

        const url =`${apiUrl}/DelayAndCancellation/GetArrivalFlightDetail?flightIdentity=${flightIdentity}`;
       
        return await fetch(url.toString(), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
            .then(checkStatus)
            .then(parseJSON)
            .catch((error: any) => {
                console.log("error while calling the api ", error);
                throw new Error("API Call failed: " + error.message + "");
            });
    
        }
        export async function DeleteMaintdelay(token:string,maintDncId:string):Promise<boolean>{
            const url =`${apiUrl}/DelayAndCancellation/DeleteMaintDelays?maintDncId=${maintDncId}`;
            return await fetch(url.toString(), {
                method: "Delete",
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            })
                .then(checkStatus)
                .then(parseJSON)
                .catch((error: any) => {
                    console.log("error while calling the api ", error);
                    throw new Error("API Call failed: " + error.message + "");
                });
        }

        export async function GetAllValidAircraft(  
            token: string
          ): Promise<AircaftData[]> {
          
            const url=`${apiUrl}/DelayAndCancellation/GetAllValidAircraft`
            return await fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            })
              .then(checkStatus)
              .then(parseJSON)
              .catch((error: any) => {
                console.log("error while calling the api ", error);
                throw new Error("API Call failed: " + error.message + "");
              });
}
        
 export async function UpdateDelayCode(token:string,updateDelayCode:UpdateDelayCodeModel):Promise<boolean>{
            const url =`${apiUrl}/DelayAndCancellation/UpdateDelayCode`;
            return await fetch(url.toString(), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(updateDelayCode)
            })
                .then(checkStatus)
                .then(parseJSON)
                .catch((error: any) => {
                    console.log("error while calling the api ", error);
                    throw new Error("API Call failed: " + error.message + "");
                });
        }